import "./Filmovie.b6f31e6d.js";
import "./Filmovie.134ff114.js";


      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8018"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8018"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRequire("64gHy");

var $eGRKQ = parcelRequire("eGRKQ");

var $lq1xk = parcelRequire("lq1xk");
function $58761e72eb38e080$var$getFocusableElements(container) {
    return Array.from(container.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter((el)=>el.offsetParent !== null || getComputedStyle(el).position === 'fixed');
}
function $58761e72eb38e080$export$6058f017353fea26(fetchCallback, focusContainer) {
    let isLoading = false;
    window.addEventListener('scroll', async ()=>{
        const { scrollTop: scrollTop, scrollHeight: scrollHeight, clientHeight: clientHeight } = document.documentElement;
        if (scrollTop + clientHeight >= scrollHeight - 1000 && !isLoading) {
            isLoading = true;
            const focusablesBeforeLoad = focusContainer ? $58761e72eb38e080$var$getFocusableElements(focusContainer) : [];
            const activeElement = document.activeElement;
            const shouldRestoreSequentialFocus = activeElement instanceof HTMLElement && focusablesBeforeLoad.length > 0 && activeElement === focusablesBeforeLoad[focusablesBeforeLoad.length - 1];
            await fetchCallback();
            if (focusContainer && shouldRestoreSequentialFocus) {
                const focusablesAfterLoad = $58761e72eb38e080$var$getFocusableElements(focusContainer);
                const firstNewFocusable = focusablesAfterLoad[focusablesBeforeLoad.length];
                if (firstNewFocusable) firstNewFocusable.focus();
            }
            isLoading = false;
        }
    });
}


function $158c91836dc40282$export$a1f91be8c1bacc4e(form, callback) {
    form.addEventListener('submit', (e)=>{
        e.preventDefault();
        const input = form.querySelector('input');
        if (!input) return;
        const query = input.value.trim();
        if (!query) return;
        callback(query);
    });
}



var $bGyN2 = parcelRequire("bGyN2");

var $jqILx = parcelRequire("jqILx");

var $gek7u = parcelRequire("gek7u");
function $267ce293082e65ff$export$1cf292bbcd88176() {
    const select = document.querySelector('#categorySelect');
    const selectedValue = select?.value ?? 'all';
    if (selectedValue === 'all' || selectedValue === '1') return 'all';
    const parsedValue = Number(selectedValue);
    return Number.isFinite(parsedValue) ? parsedValue : 'all';
}
function $267ce293082e65ff$export$5796f65cf59f2b98(movies) {
    const selectedCategory = $267ce293082e65ff$export$1cf292bbcd88176();
    if (selectedCategory === 'all') return movies;
    return movies.filter((movie)=>movie.genre_ids.includes(selectedCategory));
}
function $267ce293082e65ff$export$7453363e6c3c0a22(language, selectedValue) {
    const select = document.querySelector('#categorySelect');
    if (!select) return;
    const previousValue = selectedValue ?? select.value ?? 'all';
    const allLabel = language === 'pl-PL' ? 'Wszystkie' : 'All';
    const options = [
        `<option value="all">${allLabel}</option>`
    ];
    (0, $gek7u.genresMap).forEach((genre, id)=>{
        const label = language === 'pl-PL' ? genre.pl : genre.en;
        options.push(`<option value="${id}">${label}</option>`);
    });
    select.innerHTML = options.join('');
    select.value = options.some((option)=>option.includes(`value="${previousValue}"`)) ? previousValue : 'all';
}
function $267ce293082e65ff$export$606046336bd238cd(onChange) {
    const select = document.querySelector('#categorySelect');
    if (!select) return;
    select.addEventListener('change', onChange);
}


function $470ecc7d686ac7bf$export$849df3a0d856eb68() {
    const filmsList = document.querySelector('.films__list');
    const form = document.querySelector('.header__nav-form');
    const categorySelect = document.querySelector('#categorySelect');
    let currentPage = 1;
    let totalPages = 1;
    let query = '';
    let noMoreVideos = false;
    let requestVersion = 0;
    let loadedMovies = [];
    const noMore = document.createElement('p');
    noMore.classList.add('no-more-videos');
    noMore.setAttribute('data-translate', 'noMoreVidoes');
    function renderCurrentMovies() {
        filmsList.innerHTML = (0, $lq1xk.renderMovies)((0, $267ce293082e65ff$export$5796f65cf59f2b98)(loadedMovies), (0, $bGyN2.currentLanguage));
    }
    function resetAndLoad() {
        requestVersion++;
        currentPage = 1;
        loadedMovies = [];
        filmsList.innerHTML = '';
        noMoreVideos = false;
        load(requestVersion);
    }
    (0, $267ce293082e65ff$export$7453363e6c3c0a22)((0, $bGyN2.currentLanguage));
    async function load(version = requestVersion) {
        if (!filmsList.children.length) (0, $jqILx.notifications).showLoader();
        noMore.innerHTML = '';
        try {
            const selectedCategory = (0, $267ce293082e65ff$export$1cf292bbcd88176)();
            const response = query ? await (0, $eGRKQ.searchMovies)(query, currentPage, (0, $bGyN2.currentLanguage)) : selectedCategory === 'all' ? await (0, $eGRKQ.fetchTrending)(currentPage, (0, $bGyN2.currentLanguage)) : await (0, $eGRKQ.fetchMoviesByGenre)(selectedCategory, currentPage, (0, $bGyN2.currentLanguage));
            if (version !== requestVersion) return;
            totalPages = response.total_pages ?? 1;
            loadedMovies = currentPage === 1 ? response.results : [
                ...loadedMovies,
                ...response.results
            ];
            renderCurrentMovies();
        } catch (error) {
            if (version !== requestVersion) return;
            (0, $jqILx.notifications).error();
            filmsList.innerHTML += `<li><button><p>${error}</p></button></li>`;
        } finally{
            if (version === requestVersion) (0, $jqILx.notifications).hideLoader();
        }
    }
    (0, $158c91836dc40282$export$a1f91be8c1bacc4e)(form, (newQuery)=>{
        query = newQuery;
        resetAndLoad();
    });
    (0, $267ce293082e65ff$export$606046336bd238cd)(()=>{
        resetAndLoad();
    });
    (0, $58761e72eb38e080$export$6058f017353fea26)(async ()=>{
        if (noMoreVideos) return;
        if (currentPage >= totalPages) {
            noMoreVideos = true;
            (0, $jqILx.notifications).noMoreMovies();
            // noMore.innerHTML = `No more videos to load`;
            filmsList.after(noMore);
            (0, $bGyN2.applyTranslations)();
            return;
        }
        currentPage++;
        await load();
    }, filmsList);
    resetAndLoad();
    // Listen to language change
    document.addEventListener('languageChanged', ()=>{
        (0, $267ce293082e65ff$export$7453363e6c3c0a22)((0, $bGyN2.currentLanguage), categorySelect?.value);
        resetAndLoad();
    });
}


(0, $470ecc7d686ac7bf$export$849df3a0d856eb68)();


//# sourceMappingURL=Filmovie.44a00329.js.map
